import React, { useEffect, useState, useContext, useRef } from 'react';
import moment from 'moment-timezone';
import BackButton from "../../components/back_button";
import { Popover } from '@headlessui/react';
import Footer from '../../components/footer';
import { AuthContext } from '../../contexts/auth';
import ComboboxAutocomplete from '../../components/combobox_autocomplete';
import { PlusIcon } from '@heroicons/react/24/outline';
import { Link } from 'wouter';
import { getJustificationsCompanyList } from '../../services/api_justifications';
import { getTipiGiustificativi, getRichiesteGiustificativi, createRichiestaGiustificativo } from '../../services/api_dipendenti';
import Fetching from "../../components/fetching";
import Empty from '../../components/empty';
import { decodeGiustificativoStatus } from '../../utils';
import { getShifts } from '../../services/api_dipendenti';
import XCircleIcon from '@heroicons/react/24/outline/esm/XCircleIcon';
import CheckCircleIcon from '@heroicons/react/24/outline/esm/CheckCircleIcon';
import { ClockIcon } from '@heroicons/react/24/outline';

function formatJustificationEnd(datetimeFrom, datetimeTo) {
  const from = moment(datetimeFrom);
  const to = moment(datetimeTo);

  // Crea una copia di 'from' per evitare di modificarlo
  const fromCopy = moment(from);

  // Verifica se il datetime_to è esattamente a mezzanotte del giorno successivo
  const isNextDayMidnight =
      to.isSame(fromCopy.add(1, 'days').startOf('day'), 'day') && to.format('HH:mm') === '00:00';
  
  // Se datetime_to è a mezzanotte del giorno successivo, mantieni la stessa data di inizio per il "giorno" di fine
  const endDate = isNextDayMidnight ? from.format('DD/MM/YYYY') : to.format('DD/MM/YYYY');
  const endTime = isNextDayMidnight ? '24:00' : to.format('HH:mm');
  
  return {
      date: endDate,
      time: endTime,
  };
}


const ArNewJustificationRequest = () => {
  const backgroudColor = 'bg-indigo-200';
  const requestQuery = new URLSearchParams(location.search);
  const requestDay = requestQuery.get('day') || '';

  const { loading, token } = useContext(AuthContext);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingSummary, setIsLoadingSummary] = useState(false);
  const [isError, setIsError] = useState(false);
  const [isErrorSummary, setIsErrorSummary] = useState(false);
  const [giustificativi, setGiustificativi] = useState([]);
  const [giustificativiSummary, setGiustificativiSummary] = useState([]);
  const [giustificativoSelected, setGiustificativoSelected] = useState('');
  const [shifts, setShifts] = useState([]); 
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [showForm, setShowForm] = useState(false);
  const messageRef = useRef(null);
  const [error, setError] = useState('');
  const [workTimeError, setWorkTimeError] = useState('');

  const [richiesta, setRichiesta] = useState({
    success: false
  });
  
  const [formData, setFormData] = useState({
    date_from: requestDay,
    date_to: requestDay,
    time_from: '',
    time_to: '',
    justification: '',
    note: ''
  });
  const [formErrors, setFormErrors] = useState({});
  const [isInputReset, setIsInputReset] = useState(false);

  useEffect(() => {
    if (Object.keys(formErrors).length > 0 || richiesta.error) {
      if (messageRef.current) {
        messageRef.current.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [formErrors, richiesta.error]);

  const isValidDateFormat = (date) => {
    // Verifica se la data è nel formato YYYY-MM-DD
    const regex = /^\d{4}-\d{2}-\d{2}$/;
    return regex.test(date);
  };  

  const formatInputDate = (input) => {
    if(!input)
      return '';
    const cleanedInput = input.replace(/\D/g, '');
  
    if (cleanedInput.length === 8) {
      // Converte da GG/MM/AAAA a YYYY-MM-DD
      return `${cleanedInput.substring(4, 8)}-${cleanedInput.substring(2, 4)}-${cleanedInput.substring(0, 2)}`;
    }
  
    return input;
  };
  
  const formatInputDateToShow = (input) => {
    if(!input)
      return '';
    
    const cleanedInput = input.replace(/\D/g, '');
  
    if (cleanedInput.length === 8) {
      // Converte da GG/MM/AAAA a YYYY-MM-DD
      return `${cleanedInput.substring(0, 2)}/${cleanedInput.substring(2, 4)}/${cleanedInput.substring(4, 8)}`;
    }
  
    return input;
  };

  const handleJRTimeChange = (field, e) => {
    let inputValue = e.target.value;

    inputValue = inputValue.replace(/\D/g, '');
    inputValue = inputValue.slice(0, 4);

    let formattedTime = inputValue.replace(/(\d{2})(\d{0,2})/, "$1:$2");

    if (inputValue.length <= 2 && e.target.value.length < formattedTime.length) {
        formattedTime = formattedTime.replace(":", "");
    }

    setFormDataValue(field, formattedTime);
};


const handleJRTimeBlur = (field) => {
  let formattedTime = formData[field] || '';

  formattedTime = formattedTime.replace(/\D/g, '');

  while (formattedTime.length < 4) {
      formattedTime += '0';
  }

  formattedTime = formattedTime.slice(0, 4);

  const hours = parseInt(formattedTime.slice(0, 2), 10);
  const minutes = parseInt(formattedTime.slice(2), 10);

  const formattedInput = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;

  const isValidTime = hours >= 0 && hours <= 24 && minutes >= 0 && minutes < 60;
  if (!isValidTime || (hours === 24 && minutes > 0)) {
      setFormDataValue(field, ''); 
      Swal.fire({
          icon: 'error',
          title: 'Orario non valido',
          text: 'Inserisci un orario valido entro 24:00.'
      });
      return;
  }

  setFormDataValue(field, formattedInput);
};


  const setFormDataValue = (key, value) => {
    let formattedValue = value;
    let toShow = value;
    // Se la data non è nel formato corretto e richiede conversione, la converte
    if ((key === 'date_from' || key === 'date_to') && !isValidDateFormat(value)) {
      formattedValue = formatInputDate(value);
      toShow = formatInputDateToShow(toShow);
    }
  
    // Aggiorna lo stato formData separatamente per 'date_from' e 'date_to'
    setFormData((prevState) => ({ ...prevState, [key]: toShow}));
  
    // Verifica se le date sono nel mese corrente
    const currentMonth = moment().startOf('month');
    const dateFromFormatted = formatInputDate(formData.date_from);
    const dateToFormatted = formatInputDate(formData.date_to);
    const dateFrom = moment(dateFromFormatted, 'YYYY-MM-DD');
    const dateTo = moment(dateToFormatted, 'YYYY-MM-DD');
  
    if (dateFrom.isBefore(currentMonth, 'month') || dateTo.isBefore(currentMonth, 'month')) {
      // Se le date sono antecedenti al mese corrente, nascondi i turni
      setShifts([]);
    } else {
      // Se le date sono valide, e se entrambe sono impostate, carica i turni
      if (key === 'date_from' && formData.date_to) {
        fetchShifts(formattedValue, dateToFormatted);
      } else if (key === 'date_to' && formData.date_from) {
        fetchShifts(dateFromFormatted, formattedValue);
      }
    }
  
    // Rimuovi errori specifici del campo modificato
    setFormErrors((prevState) => {
      if (prevState[key]) {
        const newErrors = { ...prevState };
        delete newErrors[key];
        return newErrors;
      }
      return prevState;
    });
  };

  // reset campo input data se viene modificato un carattere, altrimenti non aggiorna la visualizzazione dei turni
  const handleKeyDown = (e) => {
    const { name } = e.target;

    if (!isInputReset) {
      setFormData((prevState) => ({ ...prevState, [name]: '' }));
      setIsInputReset(true);
    }
  };

  const handleBlur = () => {
    setIsInputReset(false);
  };
  
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormErrors({});
    setFormDataValue(name, value);
  };


  useEffect(() => {

    if(!token)
      return

    if(formData.date_from && formData.date_to)
      fetchShifts(formatInputDate(formData.date_from), formatInputDate(formData.date_from));

  }, [token]);
  

  useEffect(() => {
    // fetch data
    fetchData(currentPage);
  }, [currentPage]);

  const fetchData = async (page = 1) => {
    setIsLoading(true);
    setIsLoadingSummary(true);
    setIsError(false);
    setIsErrorSummary(false);
    
    try {
      const giustificativi = await getTipiGiustificativi(token);
      setGiustificativi(giustificativi);
    } catch (error) {
      console.error('Error fetching justifications:', error);
      setIsError(true);
    } finally {
      setIsLoading(false);
    }

    try {
      const query = {
          page_size: 10,
          page: page,   
      };
      
      const giustificativiSummary = await getRichiesteGiustificativi(token, query);
      setGiustificativiSummary(giustificativiSummary.results);
      setTotalPages(Math.ceil(giustificativiSummary.count / 10));

    } catch (error) {
      console.error('Error fetching justifications:', error);
      setIsErrorSummary(true);
    }
    finally {
      setIsLoadingSummary(false);
    }
  };


  const fetchShifts = async (start, end) => {
    try {
      const shiftsData = await getShifts(token, { start, end });
      setShifts(shiftsData);
    } catch (error) {
      console.error('Error fetching shifts:', error);
    }
  };


  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(prevPage => prevPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(prevPage => prevPage - 1);
    }
  };

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const shouldShowForm = query.get('showForm') === 'true';
    setShowForm(shouldShowForm);
  }, [location]);

  const toggleForm = () => {
    setShowForm(!showForm);
    setGiustificativoSelected('');
    setFormData({
      date_from: '',
      date_to: '',
      time_from: '',
      time_to: '',
      justification: '',
      note: ''
    });
    setFormErrors({});
    setShifts([]);
    setRichiesta({ success: false, message: '', error: false, verbose: '' });
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
  
    let errors = {};
  
    if (!formData.date_from) {
      errors.date_from = 'Scegliere il giorno "Dal"';
    }
    if (!formData.date_to) {
      errors.date_to = 'Scegliere il giorno "Al"';
    }
    if (formData.date_from > formData.date_to) {
      errors.date_to = 'La data di fine deve essere successiva alla data di inizio';
    }
  
    // Verifica se la data è nel mese corrente
    // const currentMonth = moment().startOf('month');
    // const dateFrom = moment(formData.date_from, 'DD/MM/YYYY');
    // const dateTo = moment(formData.date_to, 'DD/MM/YYYY');
  
    // if (dateFrom.isBefore(currentMonth, 'month') || dateTo.isBefore(currentMonth, 'month')) {
    //   errors = { ...errors, date_from: 'I giustificativi non possono essere richiesti nei mesi precedenti a quello corrente.' };
    //   errors = { ...errors, date_to: 'I giustificativi non possono essere richiesti nei mesi precedenti a quello corrente.' };
    // }
  
    if (!formData.justification) {
      errors = { ...errors, justification: 'Scegli il giustificativo. Il campo è obbligatorio' };
    }
  
    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      setShifts([]);
      
      if (messageRef.current) {
        messageRef.current.scrollIntoView({ behavior: 'smooth' });
      }
      return;
    }

    setFormErrors({});


    const formattedDateFrom = formatInputDate(formData.date_from);
    let formattedDateTo = formatInputDate(formData.date_to);

    
    let datetime_from = (`${formattedDateFrom}T00:00:00`);
    let datetime_to = (`${formattedDateTo}T23:59:59`);

    
    if (formData.time_from && formData.time_to) {
      if (formData.time_to == '24:00') {
        formData.time_to = '00:00';
      
        formattedDateTo = moment(formattedDateTo, "YYYY-MM-DD").add(1, 'days').format("YYYY-MM-DD");
      }
      
      datetime_from = (`${formattedDateFrom}T${formData.time_from}:00`);
      datetime_to = (`${formattedDateTo}T${formData.time_to}:00`);

    }
  
    try {
      await createRichiestaGiustificativo(token, {
        datetime_from,
        datetime_to,
        note: formData.note,
        justification: formData.justification
      });
      setRichiesta({ success: true, message: 'Richiesta inviata correttamente' });
      setTimeout(() => setRichiesta({ success: false, message: '' }), 3000);
  
      setShowForm(false);
      setFormData({
        date_from: '',
        date_to: '',
        time_from: '',
        time_to: '',
        justification: '',
        note: ''
      });
      setGiustificativoSelected('');
      fetchData();
    } catch (error) {
      let errorDetails = error.response?.data ? Object.values(error.response.data).flat().join(', ') : '';
      setRichiesta({ error: true, message: "Errore durante l'invio della richiesta", verbose: errorDetails });
    }
  };  

  const formatDuration = (durationInMinutes) => {
    const totalHours = Math.floor(durationInMinutes / 60);
    const remainingMinutes = durationInMinutes % 60;
  
    if (totalHours > 0 && remainingMinutes > 0) {
      return `${totalHours} h, ${remainingMinutes} min`;
    } else if (totalHours > 0) {
      return `${totalHours} h`;
    } else if (remainingMinutes > 0) {
      return `${remainingMinutes} min`;
    } else {
      return `0 min`;
    }
  };

  const isButtonDisabled = giustificativi.length === 0;

  if (isError) return <div>Error loading data</div>;

  return <div>
    <div className="min-h-full">
      <Popover as="header" className={`${backgroudColor}`}>
        <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:max-w-7xl lg:px-8">
          <div className="relative flex flex-wrap items-center justify-center lg:justify-between">
            <div className="w-full -5 lg:border-t lg:border-white lg:border-opacity-20">
              <div className="flex justify-center my-2 py-2">
                <h2 className="text-center text-2xl font-semibold text-indigo-800">I tuoi giustificativi</h2>
              </div>
            </div>
          </div>
        </div>
      </Popover>

      <section>
        <div className="container-fluid w-full px-4 pt-2">

          <div className="grid grid-cols-6 gap-4 mt-2 items-center px-10">
            
            <div className='col-span-4 flex items-center mb-6 mt-4'>
              <h3 className="text-base font-semibold leading-6 text-gray-900">Inserisci una nuova richiesta di Giustificativo</h3>
              <button
                onClick={toggleForm}
                className={`ml-4 text-sm p-2 rounded-md font-semibold ${showForm ? 'bg-gray-200 text-gray-800 hover:bg-gray-400 hover:text-white' : 'bg-indigo-500 text-white hover:bg-indigo-400'}`}
              >
                {showForm ? 'Annulla' : 'Crea Richiesta'}
              </button>
            </div>

            {
              richiesta.success && (
                <div className="col-span-4" ref={messageRef}>  
                  <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded relative" role="alert">
                    <strong className="font-bold"></strong>
                    <span className="block sm:inline"> {richiesta.message}</span>
                  </div>
                </div>
              )
            }

            {(Object.keys(formErrors).length > 0 || richiesta.error) && (
              <div className="col-span-4" ref={messageRef}>
                {richiesta.error && (
                  <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative" role="alert">
                    <strong className="font-bold">Errore!</strong>
                    <span className="block sm:inline"> {richiesta.message}</span><br />
                    <span className="block sm:inline"> {richiesta.verbose}</span>
                  </div>
                )}
                {Object.keys(formErrors).length > 0 && (
                  <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative" role="alert">
                    <ul className="list-disc ml-5">
                      {Object.values(formErrors).map((error, index) => (
                        <li key={index}>{error}</li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            )}
            
          </div>
        </div>
        {(isLoading) && <Fetching />}

        {showForm &&      
          <div className="px-4 sm:px-6 lg:px-8">
            <div className="-mx-4 mt-3 ring-1 ring-gray-300 mx-1 rounded-lg">
              <form onSubmit={handleSubmit} className='pb-4 pt-2 mx-2'>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-2 items-center px-10">
                  <div className='col-span-1 md:col-span-1'>
                    <label htmlFor="giustificativo" className="text-sm font-semibold text-gray-900">
                      Giustificativo
                    </label>
                  </div>
                  <div className='col-span-4 sm:col-span-3'>
                    <ComboboxAutocomplete
                      options={giustificativi.map((giustificativo, giustificativoIdx) => ({ 
                        id: giustificativo.id, 
                        name: giustificativo.justification.description, 
                        value: giustificativoIdx + 1,
                        has_hours: giustificativo.justification.has_hours 
                      }))}
                      bgActiveColor="bg-gray-100"
                      textActiveColor="text-gray-900"
                      placeholder='Seleziona il giustificativo...'
                      onChange={(selected) => {
                        setGiustificativoSelected(selected)
                        setFormDataValue('justification', selected.id)
                      }}
                      value={giustificativoSelected}
                      positionOptions='relative'
                    />
                  </div>
                  
                  {giustificativi.length > 0 && (
                    <div className='col-span-4 py-3'>
                      <div className='text-sm font-semibold text-gray-900 pb-3'>Anteprima turno</div>
                      <div className='overflow-x-auto'>
                        <div className='overflow-y-auto auto max-h-[40vh] rounded-lg'>
                          <table className="min-w-full bg-white shadow-md border border-gray-200">
                            <thead className="bg-indigo-200 text-gray-900 sticky top-0 bg-indigo-100">
                              <tr>
                                <th className="py-2 px-4 text-left text-sm font-semibold" style={{ width: '20%' }}>Giorno</th>
                                <th className="py-2 px-4 text-left text-sm font-semibold" style={{ width: '16%' }}>Inizio</th>
                                <th className="py-2 px-4 text-left text-sm font-semibold" style={{ width: '16%' }}>Fine</th>
                                <th className="py-2 px-4 text-left text-sm font-semibold" style={{ width: '16%' }}>Inizio Pausa</th>
                                <th className="py-2 px-4 text-left text-sm font-semibold" style={{ width: '16%' }}>Fine Pausa</th>
                                <th className="py-2 px-4 text-left text-sm font-semibold" style={{ width: '16%' }}>Durata</th>
                              </tr>
                            </thead>
                            {shifts?.days?.length > 0 ? (
                
                            <tbody>
                              {shifts.days.map((day, dayIndex) => (
                                day.shifts && day.shifts.length > 0 ? (
                                  day.shifts.map((shift, shiftIndex) => (
                                    shift.time_slots && shift.time_slots.length > 0 ? (
                                      shift.time_slots.map((slot, slotIndex) => (
                                        <tr key={`${dayIndex}-${shiftIndex}-${slotIndex}`} className="border-t">
                                          {shiftIndex === 0 && slotIndex === 0 && (
                                            <td
                                              className="py-2 px-4 text-sm text-gray-900"
                                              rowSpan={day.shifts.reduce((acc, s) => acc + (s.time_slots ? s.time_slots.length : 0), 0)}
                                              style={{ width: '20%' }}
                                            >
                                              {moment(day.date).format('DD/MM/YYYY')}
                                            </td>
                                          )}
                                          <td className="py-2 px-4 text-sm text-gray-900" style={{ width: '16%' }}>{slot.start_at}</td>
                                          <td className="py-2 px-4 text-sm text-gray-900" style={{ width: '16%' }}>{slot.end_at}</td>
                                          <td className="py-2 px-4 text-sm text-gray-900" style={{ width: '16%' }}>
                                            {slot.breaks && slot.breaks.length > 0 ? slot.breaks.map((b, breakIndex) => (
                                              <div key={breakIndex}>{b.start_at}</div>
                                            )) : ''}
                                          </td>
                                          <td className="py-2 px-4 text-sm text-gray-900" style={{ width: '16%' }}>
                                            {slot.breaks && slot.breaks.length > 0 ? slot.breaks.map((b, breakIndex) => (
                                              <div key={breakIndex}>{b.end_at}</div>
                                            )) : ''}
                                          </td>
                                          <td className="py-2 px-4 text-sm text-gray-900" style={{ width: '16%' }}>{formatDuration(slot.duration)}</td>
                                        </tr>
                                      ))
                                    ) : (
                                      <tr key={`${dayIndex}-${shiftIndex}`} className="border-t">
                                        {shiftIndex === 0 && (
                                          <td
                                            className="py-2 px-4 text-sm text-gray-900"
                                            rowSpan={day.shifts.reduce((acc, s) => acc + (s.time_slots ? s.time_slots.length : 0), 0)}
                                            style={{ width: '20%' }}
                                          >
                                            {moment(day.date).format('DD/MM/YYYY')}
                                          </td>
                                        )}
                                        <td colSpan={5} className="py-2 px-4 text-sm text-gray-600">Nessun turno previsto</td>
                                      </tr>
                                    )
                                  ))
                                ) : (
                                  <tr key={dayIndex} className="border-t">
                                    <td className="py-2 px-4 text-sm text-gray-900">{moment(day.date).format('DD/MM/YYYY')}</td>
                                    <td colSpan={5} className="py-2 px-4 text-sm text-gray-600">Nessun turno previsto</td>
                                  </tr>
                                )
                              ))}
                            </tbody>
                            ) : (
                              <tbody>
                              <tr>
                                <td colSpan={window.innerWidth < 640 ? 3 : 6} className="px-8 py-4 text-center text-sm font-normal text-gray-900 whitespace-normal break-words">
                                  Inserisci le date di richiesta del giustificativo per visualizzare i turni
                                </td>
                              </tr>
                              </tbody>
                            )}
                          </table>
                        </div>
                      </div>
                    </div>
                  )}

                  <div className='col-span-2 md:col-span-1'>
                    <label htmlFor="date_from" className="text-sm font-semibold text-gray-900">
                      Dal
                    </label>
                  </div>

                  <div className="col-span-2 md:col-span-1 inline-block">
                    <div className="flex items-center">
                      <input
                        name="date_from"
                        onKeyDown={handleKeyDown}
                        onChange={handleInputChange}
                        onBlur={handleBlur}
                        value= {formData.date_from || ''}
                        type="text"
                        placeholder="ggmmaaaa"
                        maxLength={10}
                        className="border-gray-200 rounded-md focus:ring-gray-300 focus:border-gray-300 block w-40 shadow-md sm:text-sm"
                      />
                    </div>
                  </div>

                  <div className='col-span-2 md:col-span-1'>
                    <label htmlFor="date_to" className="text-sm font-semibold text-gray-900">
                      Al
                    </label>
                  </div>

                  <div className="col-span-2 md:col-span-1 inline-block">
                    <div className="flex items-center">
                      <input
                        name="date_to"
                        onKeyDown={handleKeyDown}
                        onChange={handleInputChange}
                        onBlur={handleBlur}
                        value= {formData.date_to || ''}
                        type="text"
                        placeholder="ggmmaaaa"
                        maxLength={10}
                        className="border-gray-200 rounded-md focus:ring-gray-300 focus:border-gray-300 block w-40 shadow-md sm:text-sm"
                      />
                    </div>
                  </div>

                  {giustificativoSelected && giustificativoSelected.has_hours && (
                    <>
                      <div className='col-span-2 md:col-span-1'>
                        <label htmlFor="time_from" className="text-sm font-semibold text-gray-900">
                          Dalle ore
                        </label>
                      </div>

                      <div className="col-span-2 md:col-span-1 inline-block">
                        <div className="flex items-center">
                          {/* <input
                            type="time"
                            onChange={(e) => setFormDataValue('time_from', e.target.value)}
                            value={formData.time_from || ''}
                            className="border-gray-200 rounded-md focus:ring-gray-300 focus:border-gray-300 block w-40 shadow-md sm:text-sm"
                          /> */}
                          <div style={{ position: 'relative', display: 'inline-block', width: 'fit-content' }}>
                            <input 
                              type="text"
                              placeholder='hh:mm' 
                              value={formData.time_from || ''} 
                              onInput={(e) => handleJRTimeChange('time_from', e)}
                              onBlur={() => handleJRTimeBlur('time_from')}  
                              className="t-1 p-1 pl-4 border-gray-200 rounded-md focus:ring-indigo-500 focus:border-indigo-500 block w-40 shadow-md sm:text-sm required" 
                            />
                            <span style={{ position: 'absolute', top: '50%', right: '8px', transform: 'translateY(-50%)' }}>
                              <ClockIcon className='w-4 h-4' />
                            </span>
                          </div>
                        </div>
                      </div>

                      <div className='col-span-2 md:col-span-1'>
                        <label htmlFor="time_to" className="text-sm font-semibold text-gray-900">
                          Alle ore
                        </label>
                      </div>
                      
                      <div className="col-span-2 md:col-span-1 inline-block">
                        <div className="flex items-center">
                          {/* <input
                            type="time"
                            onChange={(e) => setFormDataValue('time_to', e.target.value)}
                            value={formData.time_to || ''}
                            className="border-gray-200 rounded-md focus:ring-gray-300 focus:border-gray-300 block w-40 shadow-md sm:text-sm"
                          /> */}
                          <div style={{ position: 'relative', display: 'inline-block', width: 'fit-content' }}>
                            <input 
                              type="text"
                              placeholder='hh:mm' 
                              value={formData.time_to || ''} 
                              onInput={(e) => handleJRTimeChange('time_to', e)}
                              onBlur={() => handleJRTimeBlur('time_to')}
                              className="t-1 p-1 pl-4 border-gray-200 rounded-md focus:ring-indigo-500 focus:border-indigo-500 block w-40 shadow-md sm:text-sm required" 
                            />
                            <span style={{ position: 'absolute', top: '50%', right: '8px', transform: 'translateY(-50%)' }}>
                              <ClockIcon className='w-4 h-4' />
                            </span>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                  <div className='col-span-4 md:col-span-1'>
                    <label htmlFor="giustificativo" className="text-sm font-semibold text-gray-900">
                      Note
                    </label>
                  </div>
                  <div className='col-span-4 sm:col-span-3'>
                    <input
                      onChange={(e) => setFormDataValue('note', e.target.value)}
                      value={formData.note || ''}
                      type="text"
                      className="w-full border-gray-200 rounded-md focus:ring-gray-300 focus:border-gray-300 block shadow-md sm:text-sm"
                    />
                  </div>
                  <div className='col-span-1'></div>
                </div>

                <div className='col-span-1 flex justify-center pt-5'>
                  {giustificativi.length === 0 ? (
                    <div className='text-sm font-semibold text-indigo-800'>
                      Non sono presenti giustificativi attivi. La richiesta non può essere inviata.
                    </div>
                  ) : (
                    <button
                      type="submit"
                      className={`bg-indigo-500 text-white text-sm px-4 py-2 rounded-md focus:outline-none w-24 font-semibold ${
                        isButtonDisabled ? 'bg-gray-300 cursor-not-allowed' : 'hover:bg-indigo-200 focus:bg-indigo-200'
                      }`}
                      disabled={isButtonDisabled}
                    >
                      Invia
                    </button>
                  )}
                </div>

              </form>
            </div>

          </div>
        }
        
      </section>

      {// riepilogo
      }
      <section>
        <div className="container-fluid w-full px-4 pt-2">
          <div className="grid grid-cols-6 gap-4 mt-2 items-center px-10">
            <div className='col-span-4'>
              <h3 className="text-base font-semibold leading-6 text-gray-900">Riepilogo</h3>
            </div>
          </div>
        </div>
        
        {(isLoadingSummary) && <Fetching />}
      </section>
      
      {
        !isLoadingSummary && giustificativiSummary.length == 0 && (
          <div className='px-4'>
            <Empty />
          </div>
          
        )
      }
      {
        (!isLoading && giustificativiSummary.length > 0) && (
          <div className="px-4 sm:px-6 lg:px-8">
            <div className="-mx-4 mt-3 ring-1 ring-gray-300 mx-1 rounded-lg" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
              <table className="min-w-full divide-y divide-gray-300">
                <thead className='sticky top-0 z-10 bg-white'>
                  <tr>
                    <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">
                      Codice
                    </th>
                    <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">
                      Giustificativo
                    </th>
                    <th
                      scope="col"
                      className="pl-4 sm:pl-6 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      Dal
                    </th>
                    <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">
                      Al
                    </th>
                    <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">
                      Stato
                    </th>
                  </tr>
                </thead>
                <tbody>
                {giustificativiSummary.map((item) => {
                  const { date: endDate, time: endTime } = formatJustificationEnd(item.datetime_from, item.datetime_to);
                  return [
                    <tr key={item.id}>
                      <td className='border-t border-gray-200 relative py-4 pl-4 pr-3 text-sm sm:pl-6'>
                        {item.justification.justification.code}
                      </td>
                      <td className='border-t border-gray-200 relative py-4 pl-4 pr-3 text-sm sm:pl-6'>
                        {item.justification.justification.description}
                      </td>
                      <td className="border-t border-gray-200 relative py-4 pl-4 pr-3 text-sm sm:pl-6">
                        {moment(item.datetime_from).format('HH:mm:ss') === '00:00:00' && moment(item.datetime_to).format('HH:mm:ss') === '23:59:59' ? (
                          moment(item.datetime_from).format('DD/MM/YYYY')
                        ) : (
                          moment(item.datetime_from).format('DD/MM/YYYY HH:mm')
                        )}
                      </td>
                      <td className="border-t border-gray-200 relative py-4 pl-4 pr-3 text-sm sm:pl-6">
                        {`${endDate} ${endTime}`}
                      </td>
                      <td className="border-t border-gray-200 text-center relative py-4 pl-4 pr-3 text-sm sm:pl-6">
                        {item.status === 'approved' ? (
                          <CheckCircleIcon className="w-5 h-5 text-teal-500 mx-auto" />
                        ) : item.status === 'rejected' ? (
                          <XCircleIcon className="w-5 h-5 text-red-500 mx-auto" />
                        ) : (
                          <div>In attesa di approvazione</div>
                        )}
                      </td>
                    </tr>,
                    (
                      item.note && item.note.length > 0 && (
                        <tr key={`${item.id}-note`} className="border-b border-gray-200 bg-indigo-50">
                          <td colSpan="6" className="py-3 px-6 text-gray-600 text-sm text-left"><span className='font-semibold text-gray-700'>Note: </span> {item.note}</td>
                        </tr>
                      )
                    )
                  ]})}
                  {/* Paginazione */}
                  <tr className='bg-gray-50 sticky bottom-0 z-10'>
                    <td colSpan="10" className="py-4">
                      <div className="flex items-center justify-between">
                        <button
                          onClick={handlePreviousPage}
                          disabled={currentPage === 1}
                          className={`border rounded-md shadow-sm text-sm font-semibold text-center px-3 py-1 ml-4 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 ${
                            currentPage === 1 ? 'text-gray-800 cursor-not-allowed hover:bg-gray-200' : 'hover:bg-gray-200'
                          }`}
                        >
                          Pagina precedente
                        </button>

                        <div className="text-sm font-semibold text-gray-800 px-2">
                          Pagina {currentPage} di {totalPages}
                        </div>

                        <button
                          onClick={handleNextPage}
                          disabled={currentPage === totalPages}
                          className={`border rounded-md shadow-sm text-sm font-semibold text-center px-3 py-1 mr-4 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 ${
                            currentPage === totalPages ? 'text-gray-800 cursor-not-allowed hover:bg-gray-200' : 'hover:bg-gray-200'
                          }`}
                        >
                          Pagina successiva
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        )
      }
    </div>
    <div className='mt-10'>
      <Footer />
    </div>
  </div>;
};

export default ArNewJustificationRequest
